import { render, staticRenderFns } from "./TaskEditorDrawer.vue?vue&type=template&id=0e148baa&scoped=true"
import script from "./TaskEditorDrawer.vue?vue&type=script&lang=js"
export * from "./TaskEditorDrawer.vue?vue&type=script&lang=js"
import style0 from "./TaskEditorDrawer.vue?vue&type=style&index=0&id=0e148baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e148baa",
  null
  
)

export default component.exports